import { storeToRefs } from 'pinia';
import { useCartStore } from '~/stores/useCartStore';

export default function useCartScenarios (appContext) {
  if (!appContext) {
    throw new Error('You must provide the nuxt app context/$pinia to use this composable');
  }
  const cartStore = useCartStore()
  const {
    cartScenarios
  } = storeToRefs(cartStore)
  const getAttrFromCartScenario = (cart, attributeName) => {
    let attributeVal = ''
    getScenario()
    cart?.cartItemGroupList?.forEach(group => {
      const cartScenario = cartScenarios?.value[cart.id]
      const groupId = group.groupId
      attributeVal = cartScenario?.[groupId] ? cartScenario?.[groupId]?.[attributeName] : attributeVal || null
    })
    return attributeVal
  }
  const setScenario = (updateCart, attributeName, attributeVal) => {
    let tlmCartScenarios = {}
    if (appContext.$storage.getLocalStorage('tlmCartScenarios')) {
      tlmCartScenarios = appContext.$storage.getLocalStorage('tlmCartScenarios');
    }
    updateCart?.cartItemGroupList?.forEach(group => {
      if (tlmCartScenarios[updateCart.id]?.[group.groupId]) {
        tlmCartScenarios[updateCart.id][group.groupId][attributeName] = attributeVal
      } else {
        tlmCartScenarios[updateCart.id] = { [group.groupId]: { [attributeName]: attributeVal } }
      }
    })
    appContext.$storage.setLocalStorage('tlmCartScenarios', JSON.stringify(tlmCartScenarios));
  }
  const getScenario = () => {
    if (appContext.$storage.getLocalStorage('tlmCartScenarios')) {
      cartScenarios.value = appContext.$storage.getLocalStorage('tlmCartScenarios') || cartScenarios.value
    }
    return cartScenarios
  }
  const deleteCartScenarioCookie = () => {
    appContext.$storage.removeLocalStorage('tlmCartScenarios');
  }
  return {
    setScenario,
    getAttrFromCartScenario,
    getScenario,
    deleteCartScenarioCookie
  }
}
